import { Box } from "@mui/material";
import { NavBar } from "../navbar";
import { ContactUsSection } from "../contact";
import AboutUsPage from "./components";

import { useEffect } from "react";

export default function Resources() {
  useEffect(() => {
    document.title = "About Us";
  }, []);

  return (
    <Box sx={{ margin: 0, padding: 0 }}>
      <NavBar />
      <AboutUsPage />
      <ContactUsSection />
    </Box>
  );
}
